import type { ComponentType } from 'react';

import {
  ActivityIcon,
  BellIcon,
  GiftIcon,
  HomeIcon,
  WalletIcon,
} from '../components/ui';

export interface CabNavItem {
  /** App-relative path (resolved under ``/app`` by the shell). */
  to: string;
  /** Exact-match active state (for the index/dashboard route). */
  endMatch?: boolean;
  key: string;
  Icon: ComponentType<{ size?: number }>;
  /** Reachable + used for the topbar title, but not rendered in the
   *  sidebar (notifications live behind the topbar bell). */
  hidden?: boolean;
}

/** Cabinet navigation — single source for the sidebar, the mobile
 * drawer and the topbar title. ``hidden`` items resolve the topbar
 * title but aren't shown in the sidebar. */
export const CAB_NAV: readonly CabNavItem[] = [
  { to: '/', endMatch: true, key: 'dashboard', Icon: HomeIcon },
  { to: '/wallet', key: 'wallet', Icon: WalletIcon },
  { to: '/activity', key: 'activity', Icon: ActivityIcon },
  { to: '/referrals', key: 'referrals', Icon: GiftIcon },
  { to: '/notifications', key: 'notifications', Icon: BellIcon, hidden: true },
];
